import React, { useState } from "react";

import Context from "./Context";

import PageTitleNew from "../../ui/PageTitleNew";
import Table from "./Table";
//import ModalForm from "./Form/Modal";

export default function Index() {
  return (
    <Context>
      <div className="wrapper_assestment invite_wrapper">
        <PageTitleNew title="Book of Business" />

        <div className="ibox-content mt20">
          <Table />
        </div>
      </div>
    </Context>
  );
}
